export default {
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    // 综合判断是否为移动设备
    const isMobileDevice = () => {
      // 优先通过屏幕宽度判断
      const widthMatch = window.innerWidth <= 768;

      // 补充触摸设备检测（部分华为平板/折叠屏可能需要）
      const isTouchDevice =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;

      // 针对华为设备的UA补充判断
      const huaweiUA =
        navigator.userAgent.toLowerCase().includes("huawei") ||
        navigator.userAgent.toLowerCase().includes("honor");

      // 综合决策（可根据实际需求调整权重）
      return widthMatch || (huaweiUA && isTouchDevice);
    };

    const updateState = () => {
      const newIsMobile = isMobileDevice();
      if (this.isMobile !== newIsMobile) {
        this.isMobile = newIsMobile;
        this.$emit("device-change", this.isMobile);
      }
    };

    // 防抖处理
    const debounce = (fn, delay) => {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    };

    const handleResize = debounce(updateState, 200);
    window.addEventListener("resize", handleResize);

    // 初始化时增加延迟，确保DOM和视口加载完成
    setTimeout(updateState, 300);

    // 页面显示时重新检测（解决从后台切回时的状态问题）
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        updateState();
      }
    });
  },
  beforeUnmount() {
    // 移除事件监听，避免内存泄漏
    window.removeEventListener("resize", this.handleResize);
  },
};
